// extracted by extract-css-chunks-webpack-plugin
module.exports = {"contact":"contact_HQx7U","part":"part_CR59x"};